module.exports = __webpack_public_path__ + "img/notazz.ed7e75e9.png";